import { useTranslation } from 'react-i18next'

import { FloatingTooltipContentText } from '../../Floating'

import * as styles from './FilePreviewErrorTooltipText.module.css'

function FilePreviewErrorTooltipText({
  className = styles.FilePreviewErrorTooltipText,
  file,
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltipContentText
      additionalText={
        file.error.isPersistent ? t(file.error.text) : file.error.text
      }
      additionalTextProps={{ className: styles.additionalText }}
      className={className}
      text={t('Error.FileUploadKey')}
      textProps={{ className: styles.text }}
    />
  )
}

export default FilePreviewErrorTooltipText
